import { ClassroomRepository } from '@xq/infrastructure';

export class GetClassroomsBySchoolIdUseCase {
  static execute(schoolId: string) {
    const classroomRepository = new ClassroomRepository();

    return classroomRepository.getClassroomsBySchoolId(schoolId);
  }
}
